import { memo } from 'react'
import { isMainnet } from '../../config'
import { Button, styled } from '@mui/material'
import { IconArrowRight } from 'components/Icons'
import { updateModal } from '../../store/app/actions/modalActions'
import { useAppDispatch } from '../../store'

const StyledButton = styled(Button)`
  gap: 4px;
  font-size: 12px;
  span {
    text-decoration: underline;
  }
`
export const ShowFaucetButton = memo(() => {
  const dispatch = useAppDispatch()
  if (isMainnet) return null
  return (
    <StyledButton
      size="small"
      onClick={() => {
        dispatch(
          updateModal({
            modal: 'faucet',
            open: true,
          }),
        )
      }}
    >
      <span>Get Test Tokens</span>
      <IconArrowRight />
    </StyledButton>
  )
})
